import { MEAN_BULK_WAVE_PERIOD_LINE, WavePeriodChart } from '@/components/spotter/historicalDataTab/WavePeriodSection';
import { AlertTriggerReferenceChartProps } from '@/components/spotter/notificationTab/AlertReferenceChart';
import { useAlertsFromForm } from '@/components/spotter/notificationTab/useAlertsFromForm';
import { useSpotterContext } from '@/context/SpotterContext';

export const LINES = [MEAN_BULK_WAVE_PERIOD_LINE];

export const MeanWavePeriodAlertReferenceChart = ({ enabled = false }: AlertTriggerReferenceChartProps) => {
    const { spotterId } = useSpotterContext();
    const alerts = useAlertsFromForm();

    if (!spotterId) {
        return;
    }

    return (
        <WavePeriodChart
            chartTitle={'Mean wave period alert'}
            spotterId={spotterId}
            queryEnabled={enabled}
            showAlertLines={true}
            scaleToFitAlerts={true}
            lines={LINES}
            alertLines={alerts}
        />
    );
};
